import React from 'react';
import { useSelector } from 'react-redux';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid, Typography } from '@hbf/dsl';
import { RequiredDocumentsListing } from 'ha/modules/RequiredDocuments';

import { getRequiredDocuments } from '../../reducer';

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    margin: theme.spacing(4, 0),
  },
  subtitle: {
    marginTop: theme.spacing(1),
  },
}));

const DocumentsRequired: React.FC = () => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const documents = useSelector(getRequiredDocuments);

  if (!documents?.length) return null;

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Typography.H3>{T('ldp.required_docs.title')}</Typography.H3>
        <Typography.Paragraph className={classes.subtitle}>
          {T('ldp.required_docs.subtitle')}
        </Typography.Paragraph>
      </Grid>
      <Grid item xs={12}>
        {!!documents.length && (
          <RequiredDocumentsListing documentsList={documents} />
        )}
      </Grid>
    </Grid>
  );
};

export { DocumentsRequired };
